import { jsx, jsxs } from 'react/jsx-runtime';
import { Loader } from '@mantine/core';
import { useMemo, useCallback } from 'react';
import { ExternalSystem } from './ExternalSystem.js';
import { Filters } from './Filters.js';
import { JumpLines } from './JumpLines.js';
import { Symbols } from './Symbols.js';
import { System } from './System.js';
import { SystemMarker } from './SystemMarker.js';
import { SystemNames } from './SystemNames.js';
import useStyles from './WarzoneMap.styles.js';
import { useWarzoneMap } from '../context/warzone-map.js';
import { useWarzoneStatus } from '../context/warzone-status.js';
var WarzoneMap = function WarzoneMap(_ref) {
  var _ref$LoaderComponent = _ref.LoaderComponent,
    LoaderComponent = _ref$LoaderComponent === void 0 ? Loader : _ref$LoaderComponent,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? "#0E0E0E44" : _ref$backgroundColor,
    _ref$maskBackgroundCo = _ref.maskBackgroundColor,
    maskBackgroundColor = _ref$maskBackgroundCo === void 0 ? "#0E0E0E88" : _ref$maskBackgroundCo,
    _ref$jumpLineWidth = _ref.jumpLineWidth,
    jumpLineWidth = _ref$jumpLineWidth === void 0 ? 4 : _ref$jumpLineWidth,
    _ref$scale = _ref.scale,
    scale = _ref$scale === void 0 ? 0.2 : _ref$scale,
    className = _ref.className,
    classNames = _ref.classNames,
    styles = _ref.styles,
    unstyled = _ref.unstyled,
    _ref$allowSelect = _ref.allowSelect,
    allowSelect = _ref$allowSelect === void 0 ? true : _ref$allowSelect,
    _ref$allowDeselect = _ref.allowDeselect,
    allowDeselect = _ref$allowDeselect === void 0 ? true : _ref$allowDeselect,
    _ref$showMarkers = _ref.showMarkers,
    showMarkers = _ref$showMarkers === void 0 ? true : _ref$showMarkers,
    _ref$showJumpLines = _ref.showJumpLines,
    showJumpLines = _ref$showJumpLines === void 0 ? true : _ref$showJumpLines,
    _ref$showSystemNames = _ref.showSystemNames,
    showSystemNames = _ref$showSystemNames === void 0 ? true : _ref$showSystemNames,
    onClickOutside = _ref.onClickOutside,
    onClick = _ref.onClick;
  var _useWarzoneMap = useWarzoneMap(),
    dataLoading = _useWarzoneMap.loading,
    mapData = _useWarzoneMap.mapData,
    setSelectedSystem = _useWarzoneMap.setSelectedSystem;
  var _useWarzoneStatus = useWarzoneStatus(),
    statusLoading = _useWarzoneStatus.loading;
  var _useStyles = useStyles({
      backgroundColor: backgroundColor,
      jumpLineWidth: jumpLineWidth
    }, {
      name: "WarzoneMap",
      classNames: classNames,
      styles: styles,
      unstyled: unstyled
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var _useMemo = useMemo(function () {
      if (!mapData) return {
        size: {
          w: 0,
          h: 0
        },
        systems: [],
        external: []
      };
      var size2 = mapData.size;
      var systems2 = Object.keys(mapData.systems).map(function (x) {
        return parseInt(x);
      });
      var external2 = Object.keys(mapData.external).map(function (x) {
        return parseInt(x);
      });
      return {
        size: size2,
        systems: systems2,
        external: external2
      };
    }, [mapData]),
    size = _useMemo.size,
    systems = _useMemo.systems,
    external = _useMemo.external;
  var clickOutsideHandler = useCallback(function (event) {
    if (onClickOutside) onClickOutside(event);
    if (!allowDeselect || event.isDefaultPrevented()) return;
    if (event.preventDefault !== void 0) event.preventDefault();
    setSelectedSystem(void 0);
  }, [onClickOutside, allowDeselect, setSelectedSystem]);
  var clickHandler = useCallback(function (event) {
    if (onClick) onClick(event);
    if (!allowSelect || event.isDefaultPrevented()) return;
    if (event.preventDefault !== void 0) event.preventDefault();
    setSelectedSystem(event.data);
  }, [onClick, allowSelect, setSelectedSystem]);
  if (dataLoading || statusLoading) {
    return /* @__PURE__ */jsx(LoaderComponent, {});
  }
  return /* @__PURE__ */jsxs("svg", {
    imageRendering: "optimizeSpeed",
    textRendering: "optimizeSpeed",
    shapeRendering: "optimizeSpeed",
    colorRendering: "optimizeSpeed",
    viewBox: "0 0 ".concat(size.w, " ").concat(size.h),
    fill: backgroundColor,
    xmlns: "http://www.w3.org/2000/svg",
    className: cx(classes.root, className),
    width: size.w * scale,
    height: size.h * scale,
    children: [/* @__PURE__ */jsx("rect", {
      width: "100%",
      height: "100%",
      className: classes.background,
      onClick: clickOutsideHandler
    }, "background"), /* @__PURE__ */jsx(Filters, {
      backgroundColor: maskBackgroundColor
    }), /* @__PURE__ */jsx("defs", {
      children: /* @__PURE__ */jsx(Symbols, {})
    }, "defs"), /* @__PURE__ */jsx("g", {
      children: systems.map(function (id) {
        return /* @__PURE__ */jsx(System, {
          solarsystemId: id,
          onClick: clickHandler
        }, "system-item-".concat(id));
      })
    }, "systems"), showJumpLines && /* @__PURE__ */jsx(JumpLines, {
      className: classes.jumpLines
    }, "lines"), showMarkers && /* @__PURE__ */jsxs("g", {
      children: [systems.map(function (id) {
        return /* @__PURE__ */jsx(SystemMarker, {
          solarsystemId: id
        }, "marker-".concat(id));
      }), external.map(function (id) {
        return /* @__PURE__ */jsx(ExternalSystem, {
          solarsystemId: id,
          onClick: clickHandler
        }, "externalsystem-item-".concat(id));
      })]
    }, "markers"), showSystemNames && /* @__PURE__ */jsxs("g", {
      children: [systems.map(function (id) {
        return /* @__PURE__ */jsx(SystemNames, {
          solarsystemId: id
        }, "system-name-".concat(id));
      }), external.map(function (id) {
        return /* @__PURE__ */jsx(SystemNames, {
          solarsystemId: id
        }, "externalsystem-name-".concat(id));
      })]
    }, "names")]
  });
};
export { WarzoneMap };